// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expand[data-v-6e367bfc]{height:auto!important;display:block!important}.new-collapse[data-v-6e367bfc]{display:none!important}", ""]);
// Exports
module.exports = exports;
